// Monetization feature flag. Ticket links are a planned PAID feature and are
// locked for now. When false: the ticketUrl input is disabled and no new
// ticketUrl is saved. Flip to true later to let creators add ticket links and
// to show "Buy tickets" on cards.
export const ENABLE_TICKET_LINKS = false;

export const FEATURES = {
  phase: 'PHASE_1',
  phases: {
    PHASE_1: {
      active: true,
      features: ['authentication', 'register', 'login', 'user roles', 'profile', 'qr code', 'events', 'event search/filter', 'buddy requests', 'accepted buddies list']
    },
    PHASE_2: {
      active: false,
      features: ['chat', 'news & reviews feed', 'posts/reviews']
    },
    PHASE_3: {
      active: false,
      features: ['organizer verification', 'artist profiles', 'advanced organizer tools', 'event analytics']
    },
    PHASE_4: {
      active: false,
      features: ['mobile app readiness', 'push notifications', 'app API separation', 'production scaling structure']
    }
  }
};

// Phase 2 and later are prepared in the codebase but intentionally disabled.
// To activate a later phase, flip the corresponding `active` flag here and
// then enable the related UI paths in the relevant pages.
